/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ChartUpwardIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="chart-upward-icon">
      <path d="M0.5,23.5 L23.5,23.5" />
      <polyline points="4.5 23.5 4.5 20.5 1.5 20.5 1.5 23.5" />
      <polyline points="10.5 23.5 10.5 16.5 7.5 16.5 7.5 23.5" />
      <polyline points="16.5 23.5 16.5 12.5 13.5 12.5 13.5 23.5" />
      <polyline points="22.5 23.5 22.5 8.5 19.5 8.5 19.5 23.5" />
      <path d="M3,13.5 L21,1.5" />
      <polyline points="20.5 5.5 21 1.5 17 1" />
    </g>
  </svg>
);

export default ChartUpwardIcon;
